// extracted by mini-css-extract-plugin
module.exports = {"ReportsPage":"ReportsPage_ReportsPage__2TmoJ","Chart":"ReportsPage_Chart__3xrS_"};